import { Link } from "react-router-dom";
import { FileSearch } from "lucide-react";

export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center text-center
      h-[calc(100vh-94px)] px-6">

      {/* Icon */}
      <div className="mb-8 flex h-16 w-16 items-center justify-center
        rounded-2xl bg-primary_tint border border-border">
        <FileSearch size={28} className="text-primary" />
      </div>

      {/* 404 number */}
      <div className="flex items-baseline gap-0.5 mb-4 leading-none"
        style={{ letterSpacing: "-4px" }}>
        <span className="text-[72px] font-medium text-text_primary">4</span>
        <span className="text-[72px] font-medium text-border_strong">0</span>
        <span className="text-[72px] font-medium text-text_primary">4</span>
      </div>

      {/* Divider label */}
      <div className="flex items-center gap-2.5 mb-3.5">
        <div className="h-px w-7 bg-border" />
        <span className="text-[11px] font-medium uppercase tracking-[0.1em]
          text-text_muted">
          Page not found
        </span>
        <div className="h-px w-7 bg-border" />
      </div>

      {/* Description */}
      <p className="text-[14px] text-text_secondary leading-[1.7]
        max-w-[280px] mb-7">
        This route doesn't exist. It may have moved, been removed,
        or you followed a broken link.
      </p>

      {/* Buttons */}
      <div className="flex flex-wrap items-center justify-center gap-2 mb-9">
        <Link to="/swiftboard">
          <button className="px-5 py-2 text-[13px] font-medium rounded-md
            bg-primary text-white hover:bg-primary_hover
            transition-colors">
            Back to dashboard
          </button>
        </Link>
        <button className="px-5 py-2 text-[13px] font-normal rounded-md
          border border-border bg-surface text-text_secondary
          hover:bg-surface_alt hover:text-text_primary
          transition-colors">
          Report issue
        </button>
      </div>

      {/* URL breadcrumb */}
      <div className="inline-flex items-center rounded-[10px] overflow-hidden
        border border-border text-[12px]">
        <span className="px-3.5 py-2 text-text_muted
          border-r border-border">
          swiftboard.app
        </span>
        <span className="px-3.5 py-2 text-text_muted
          border-r border-border">
          /dashboard
        </span>
        <span className="px-3.5 py-2 text-danger bg-danger_bg">
          404
        </span>
      </div>

    </div>
  );
}